module.exports = __webpack_public_path__ + "assets/img/Edito_Olivier-Lecler_cover.cb1718db-ps.jpg";